

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import { StringLiteralLike } from "typescript";
import {Deserializable} from "./deserializable.model";

export class SubjectTemplateDocs {

  public doc_id?: number;
  public doc_name?: string;
  public doc_template_file?: string;
  public sfdt_template_file?: string;
  public doc_save_name?: string;
  public doc_description?: string;
  public subject_com_type_id?: number;
  public brand_type_id?: number;
  public email_subject_header?: string;
  public email_template?: string;
  public is_active?: number;
  // if is of type affidavit court documents.
  // new logic to handle all document and correspondece creation in system
  public job_type_affidavit_type_id?: number;
  public job_type_court_id?: number;
  public job_type_location_id?: number;
  public job_type_id?: number;
  public job_type_document_type_id?: number;
  public email_template_HTML?: string;
  public send_to_invoice?: number;
  public send_to_report?: number;
  public send_to_report_user?: number;
  public send_to_logins?: number;
  public send_to_primary?: number;
  public original_doc__file?: string;

  // extras for angular
  public newTemplateFileName: string;
  public original_doc_file?: string;

  public doc_notes?: StringLiteralLike;
  public templates_created_tested?: boolean;


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectTemplateDocs {
    Object.assign(this, input);

    return this;
  }


}

  // Set the Stats
